import {
  hotspotIcon,
  generateCustomIconXml,
  returnProcessedContent
} from '~js/helpers'

const getMarkerMemoXml = function (marker, ath, atv, useCustomIcon, index, markerScale) {
  let memo = ''
  let width = 300
  let height = 160
  const objectId = marker.objectId
  const title = returnProcessedContent(marker.name)
  const description = returnProcessedContent(marker.description)
  const opacity = marker.opacity ? marker.opacity / 100 : 0.6

  if (marker.description && marker.description.length >= 120) {
    width = 400
    height = 450
  }
  memo += `<hotspot
    name="markerInfo_${objectId}"
    style="markerInfo"
    scale="0"
    alpha="${opacity}"
    visible="false"
    width="${width}"
    height="${height}"
    ath="${ath}"
    atv="${atv - 13}"
    zorder="${marker.index}" />`
  if (
    marker.customCoordinate &&
    marker.coordinatePlane !== 0 &&
    marker.rotation
  ) {
    const inverserotation = marker.coordinatePlane === 3
    const rx =
      marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    const ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    const rz = marker.rotation.z
    memo += `<hotspot
      name="marker_${objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ${generateCustomIconXml(marker)}
      ath="${ath}"
      atv="${atv}"
      alpha="${opacity}"
      zorder="${marker.index}"
      distorted="true"
      inverserotation="${inverserotation}"
      rx="${rx}"
      ry="${ry}"
      rz="${rz}"
      mipmapping="true"
      enabled="${!marker.disabled}"
      capture="false"
      onclick="
        set_marker_info(${index});
        marker_mousein(${objectId}, ${index});
        if(webvr.isenabled,
          close_webXR_marker(${opacity});
          ini_webXR_common_variable(${objectId});
          if(webvr.isenabled, trace('not webvr'););
          set_webXR_marker_memo_scale_html(${title}, ${description});
          set_webXR_marker_memo_position(${ath}, ${atv - 3});
          set_webXR_marker_memo_size();
          set_webXR_marker_memo_offset();
          set_webXR_button_events(${opacity}, null);
        );
      "
      onover="marker_mousein(${objectId}, ${index});"
      onout="marker_mouseout(${objectId}, ${index}, null, ${opacity});" />`
  } else {
    memo += `<hotspot
      name="marker_${objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ${generateCustomIconXml(marker)}
      ath="${ath}"
      atv="${atv}"
      alpha="${opacity}"
      zorder="${marker.index}"
      enabled="${!marker.disabled}"
      capture="false"
      onclick="
        set_marker_info(${index});
        marker_mousein(${objectId}, ${index});
        if(webvr.isenabled,
          close_webXR_marker(${opacity});
          ini_webXR_common_variable(${objectId});
          set_webXR_marker_memo_scale_html(${title}, ${description});
          set_webXR_marker_memo_position(${ath}, ${atv - 3});
          set_webXR_marker_memo_size();
          set_webXR_marker_memo_offset();
          set_webXR_button_events(${opacity}, null);
        );
      "
      onover="marker_mousein(${objectId}, ${index});"
      onout="marker_mouseout(${objectId}, ${index}, null, ${opacity});" />`
  }
  return memo
}

export default getMarkerMemoXml
